var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A7C7D83D-9F3B-491A-8A4E-BAAB7D32C849") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-home",
    transform: "translate(-535, -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(447, 18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(86, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-icon",
    transform: "translate(2, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,25.3333333 L12,25.3333333 L12,17.3333333 L20,17.3333333 L20,25.3333333 L24,25.3333333 L24,13.3333333 L16,7.33333333 L8,13.3333333 L8,25.3333333 Z M8,28 C7.26666667,28 6.63889333,27.7389333 6.11666667,27.2166667 C5.59444,26.6944 5.33333333,26.0666667 5.33333333,25.3333333 L5.33333333,13.3333333 C5.33333333,12.9111067 5.42777333,12.5111067 5.61666667,12.1333333 C5.80556,11.75556 6.06666667,11.44444 6.4,11.2 L14.4,5.2 C14.6444,5.02222667 14.9,4.88889333 15.1666667,4.8 C15.4333333,4.71110667 15.7110667,4.66666667 16,4.66666667 C16.2889333,4.66666667 16.5666667,4.71110667 16.8333333,4.8 C17.1,4.88889333 17.3556,5.02222667 17.6,5.2 L25.6,11.2 C25.9333333,11.44444 26.1944,11.75556 26.3833333,12.1333333 C26.5722667,12.5111067 26.6666667,12.9111067 26.6666667,13.3333333 L26.6666667,25.3333333 C26.6666667,26.0666667 26.4056,26.6944 25.8833333,27.2166667 C25.3610667,27.7389333 24.7333333,28 24,28 L17.3333333,28 L17.3333333,20 L14.6666667,20 L14.6666667,28 L8,28 Z",
    id: "Shape",
    fill: "#CEFAB7",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconActive);
export default __webpack_public_path__ + "static/media/home-icon-active.6bfc3cc1b8869570d28d1e20b4affe55.svg";
export { ForwardRef as ReactComponent };